<template>
    <div class="popup" v-if="realtimeLogsShow">
         <!-- <div class="content" id='viewRealTimeLogs' v-if="loading" >
                 <div v-if="loading" class="realTimeBody" v-loading="loading"></div>
         </div> -->
         <div class="content" id='viewRealTimeLogs' v-if="!aimsMoresFlag" :style="{height:nonFlag&&(viewDetail.tasks[0].status=='Run'||viewDetail.tasks[0].status=='Init')?'250Px':''}">
               <div class="title">
                    {{$t('language.popup.taskListPopup.viewLogs')}}
               <div class="icon white-close dialog-close" @click="closePage()"></div>
               </div>
                <!-- 默认加载界面 -->
               <div v-if="loading" class="realTimeBody" v-loading="loading">
                   
               </div>
               <div v-else class="realTimeBody"  :style="{height:nonFlag&&(viewDetail.tasks[0].status=='Run'||viewDetail.tasks[0].status=='Init')?'210Px':''}">
                    <div class="detail_txt" v-if="nonFlag">
                       <div v-if="nonFlag&&(viewDetail.tasks[0].status=='Run'||viewDetail.tasks[0].status=='Init')">
                            <div  class="sync_detail" style="color:#000;">{{$t('language.common.syncDetails')}}</div>
                            <div class="log-line" style="margin-bottom:3px;">
                                <div class="view-name" >{{$t('language.common.sync')}}: </div>
                                <div class="log-category-link"  :title="viewDetail.tasks[0].fromItem.nodes|getCatalog|getCatalogTitle" @click.stop="toSourceCatalog(viewDetail.tasks[0].fromItem)">{{viewDetail.tasks[0].fromItem.nodes|getCatalog}}</div>
                            </div>
                            <div class="log-line">
                                 <div class="view-name" >{{$t('language.common.with')}}: </div>
                                 <div class="log-category-link" :title="viewDetail.tasks[0].toItem.nodes|getCatalog|getCatalogTitle" @click.stop="toAimCatalog(viewDetail.tasks[0].toItem)">{{viewDetail.tasks[0].toItem.nodes|getCatalog}}</div>
                            </div>
                            <div style="float:left;margin-top:10px;height:15px;">{{$t('language.cloudSync.initSync')}}</div>
                        </div>
                       <span style="fontSize:16Px" v-if="nonFlag&&(viewDetail.tasks[0].status=='Stop'||viewDetail.tasks[0].status=='InitStop')">{{$t('language.common.taskNotRun')}}</span>
                        <!-- 若任务还没开始运行界面 -->
                      <div v-if="nonFlag&&viewDetail.tasks[0].status=='Normal'" style="fontSize:16Px;margin-top:30px;">{{$t('language.common.taskNotRun')}} </div>
                    </div>
                    <div v-else style="color:#6f7886;lineHeight:18Px;width:100%;height:50Px;marginBottom:15Px;">
                    
                    <div style="width:100%" class="logs-realTime-box progress-box-height" v-for="(item, index) in viewDetail.tasks[0].lastLog.newLog" :key="index"  :class="getHeight(item,index)">
                    <div class="view-logs-realTime-info"  style="width:100%">
                        <div  class="startTime-format" :title="getStartTile(item)">
                             {{$t('language.common.startTime')}}:{{item.taskStartTimeStr}}
                        </div>
                        <div class="startTime-format" style="marginLeft:5px;" :title="getEndTile(item)">
                            {{$t('language.common.endTime')}}:{{item.lastSyncTime}}
                        </div>
                        <div class="task-item-status">
                            <div v-if="item.response=='success'" :title="$t('language.common.success')">
                                <div class="icon-util task-success logs-failure-icon-position"></div>
                                <div class="show-status" :title="$t('language.common.success')">{{$t('language.common.success')}}</div>
                            </div>
                             <div v-if="item.response=='error'" :title="$t('language.common.failure')">
                                <div class="icon-util task-failure logs-failure-icon-position"></div>
                                <div  class="show-status" :title="$t('language.common.failure')">{{$t('language.common.failure')}}</div>
                            </div>
                             <div v-if="item.response=='cancel'" :title="$t('language.common.cancel')">
                                <div class="icon-util task-failure logs-failure-icon-position"></div>
                                <div  class="show-status" :title="$t('language.common.cancel')">{{$t('language.common.cancel')}}</div>
                            </div>
                        </div>
                        <div class="icon-util  view-collapse-positopn" :class="clickCurrent == index?'collapse-up':'collapse-down'" @click="collapse(index,item)"> </div>
                        <viewlogsDetail  ref="viewlogsDetail" :clickCurrent=clickCurrent :index=index :itemDetail='item' :allItem='viewDetail.tasks[0]' :isShow="true"> </viewlogsDetail>
                    </div>
                    </div>

                    </div>
                      
                 
               </div>
                 <div @click.stop="" @mouseover.stop=""  v-if="maxShow" style="position:absolute;bottom:10px;color:red;width:508px;margin-left:15px;">{{$t('language.cloudSync.reachMax')}}</div>
         </div>
        <!-- 多目标即时同步界面 -->
    <div class="content" id="viewLogsRealTime2" v-if="aimsMoresFlag">
        <div class="title">
            {{$t('language.popup.taskListPopup.viewLogs')}}
            <div class="icon white-close dialog-close" @click="closePage"></div>
        </div>
        <!-- 默认加载界面 -->
        <div v-if="loading" class="view-logs-body" v-loading="loading">
        </div>
        <div class="view-reallogs-all" v-else>
           <div v-if="nonFlag&&viewDetail.tasks[0].status=='Normal'" style="fontSize:16Px;margin-top:40px;color:#6f7886;margin-left:15px;">{{$t('language.common.taskNotRun')}} </div>
            <div v-else  class="view-logs-body">
                <div style="width:580px;"  class="logs-realTime-box progress-box-height" v-for="(item, index) in viewDetail.tasks[0].lastLog.newLog" :key="index"  :class="getHeight(item,index)">
                    <div class="view-logs-realTime-info" style="width:100%;">
                          <div  class="startTime-format" :title="getStartTile(item)" v-if="viewDetail.tasks[0].lastLog && viewDetail.tasks[0].lastLog.newLog">
                             {{$t('language.common.startTime')}}:{{item.taskStartTimeStr}}
                        </div>
                        <div class="startTime-format" style="marginLeft:5px;" :title="getEndTile(getLastSyncTime(item,index))">
                            {{$t('language.common.endTime')}}:{{getLastSyncTime(item,index)}}
                        </div>
                        <div class="task-item-status">
                           
                            <div v-if="showStatus(index)=='success'">
                                <div class="icon-util task-success logs-failure-icon-position"></div>
                                <div style="float:left;">{{$t('language.common.success')}}</div>
                            </div>
                            <div v-if="showStatus(index)=='failure'">
                                <div class="icon-util task-failure logs-failure-icon-position"></div>
                                <div style="float:left;">{{$t('language.common.failure')}}</div>
                            </div>

                            <div v-if="showStatus(index)=='partialSuccess'">
                                <div class="icon-util task-patial logs-status-icon-position"></div>
                                <div style="float:left;line-height:40Px;">{{$t('language.common.partialSuccess')}}</div>
    
                            </div>
                            <div v-if="showStatus(index)=='cancel'">
                                <div class="icon-util task-failure logs-status-icon-position"></div>
                                <div style="float:left;line-height:42Px;">{{$t('language.common.canceled')}}</div>
                            </div>    
                        </div>
                        <div> </div>
                        <div class="icon-util  view-collapse-positopn" :class="clickCurrent == index?'collapse-up':'collapse-down'" @click="collapse(index,item)"> </div>
                      
                        <viewSyncLogsDetail ref="viewSyncLogsDetail" :viewCurrent=clickCurrent :viewIndex=index :viewTask=viewDetail.tasks></viewSyncLogsDetail>
                        
                    </div>
                </div>
                  <div v-if="show()" class="bottom-show" :class="$i18n.locale=='deutsch'?'desh-show':'desh-not-show'">
                     {{$t('language.cloudSync.reachMax')}}
                    </div>
            </div>
        </div>
      
    </div>
    </div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
import viewlogsDetail from "@/components/common/tabs/tabs_task_list/tab_realTime_logs";
import viewSyncLogsDetail from "@/components/common/tabs/tabs_task_list/tab_singleLogs_sync_detail";
import commonUtils from "@/js/workspace/common_util.js";
export default {
      data:function(){
           return{
               realtimeLogsShow:false,
               viewDetail:{},
               nonFlag:false,
               realTimeBodyShow:false,
               loading:false,
               clickCurrent:-1,
               aimsMoresFlag:false,//标识是否是多目标的传输目录
               maxShow:false
           }
      },
      components:{
             viewlogsDetail,
             viewSyncLogsDetail
      },
      mounted(){
         
      },
      methods:{
            showStatus(index){
            var successArr=[];
            var errorArr=[];
            var cancelArr=[];
            var result;
            var viewDetail = this.viewDetail;
            for(var i=0;i<viewDetail.tasks.length;i++){
                var newlog = viewDetail.tasks[i].lastLog.newLog[index];
                if(newlog){
                var res = newlog.response;
                if(res == "success"){
                    successArr.push(res);
                }
                if(res == "error"){
                    errorArr.push(res);
                }
                 if(res == "cancel"){
                    cancelArr.push(res);
                }
                }
            }
            if(cancelArr.length){
               result="cancel";
               return result;
            }
               if(successArr.length==viewDetail.tasks.length){
               result="success";
               return result;
            }
            if(errorArr.length/viewDetail.tasks.length <=0.2 || errorArr.length/viewDetail.tasks.length<=0.2 ){
               result="partialSuccess";
               return result;
            }else{
                 result="failure";
                 return result;
            } 
          
            //let result=taskListUtils.showStatus(item);
            return result;
        },
          getDataProcessTitle(value){
              let str1=commonUtils.formatByte(value.lastLog.fileTotalReadedBytes);
              return str1;
          },
           closePage(){
               this.realtimeLogsShow=false;
               this.realTimeBodyShow=false;
           },
          toAimCatalog(item) {
            this.$parent.toAimCatalog(item);
            this.realtimeLogsShow = false;
          },
           toSourceCatalog(item) {
            this.$parent.toSyncSourceCatalog(item);
            this.realtimeLogsShow = false;
           },
            openFailedFiles() {
            let that = this;
            let failedFilesDialog = this.$parent.$refs.failedFilesDialog;
            let errorList = this.viewDetail.tasks[0].lastLog.errorList;
            let task = that.viewDetail.tasks[0];
            failedFilesDialog.transferType = this.viewDetail.type;
            failedFilesDialog.selectedArr = [];
            failedFilesDialog.unfinishData = Object.assign([], errorList);
            $.each(failedFilesDialog.unfinishData, function (index, item) {
                item.fromItem = Object.assign([], task.fromItem);
                item.toItem = Object.assign([], task.toItem);
                item.options = task.options;
            });
            that.$forceUpdate();
            failedFilesDialog.retryFailedShow = true;
        },
        getAvgSpeed(value){
           let interval=(value.lastLog.fileTotalReadedBytes/(value.lastLog.taskElaspedTimeLong/1000));
           return this.Utils.formatByteSpeed(interval);
        },
           getHeight(item,index){
            if(this.clickCurrent==index){
            if(item.type == 2 && this.viewDetail.tasks[0].lastLog && this.viewDetail.tasks[0].lastLog.newLog){
                 return 'real-time-more';
            }
            if(item.type!=1){
             return 'viewLog-real-more';
            }else{
                if(item.getViewLogCount&&item.getViewLogCount!=1){
                    return 'viewLog-box-min';
                }
                 return 'viewLog-box-more';
            }
            }else{
                return false;
            }
        },
        getRealHeight(item,index){
              if(this.clickCurrent==index){
            if(item.type!=1){
             return 'real-time-more';
            }else{
                if(item.getViewLogCount&&item.getViewLogCount!=1){
                    return 'viewLog-box-min';
                }
                 return 'real-time-more';
            }
            }else{
                return false;
            }
        },
            collapse(index,item) {
            let that=this;
            if (this.clickCurrent != index) {
                this.clickCurrent = index;
            } else {
                this.clickCurrent = -1;
            }
        },
        getStartTile(item){
          return this.$t('language.common.startTime')+item.taskStartTimeStr;
        },
        getEndTile(value){
           return this.$t('language.common.endTime')+value;   
        },
       show(){
           var tasksLength = this.viewDetail.tasks.length;
           var max = Math.floor(200/tasksLength);
           if((this.viewDetail.tasks[0].lastLog.newLog.length) >= max) {
              return true;
           }
       },
       //多目标同步时显示执行时间最长的
       getLastSyncTime(item,index){
           var allTimeLogArr = [];
           for(var i = 0; i< this.viewDetail.tasks.length;i++){
               var element = this.viewDetail.tasks[i];
               var log = element.lastLog.newLog[index];
               allTimeLogArr.push(log.taskElaspedTimeLong);
           }
           var j = allTimeLogArr.indexOf(Math.max(...allTimeLogArr));
           return this.viewDetail.tasks[j].lastLog.newLog[index].lastSyncTime;
       }
      }
}
</script>

<style>

#viewRealTimeLogs{
    width: 550px;
    /*no*/
    height: 450px;
    /*no*/
    font-size: 12Px;
}
#viewLogsRealTime2 {
    width: 620px;
    /*no*/
    height: 380px;
    /*no*/
}
.realTimeBody{
    padding: 15px;
    /*no*/
    width: 100%;
    height: 365Px;
    /*no*/
    box-sizing: border-box;
    overflow: auto;
}
.realTimeBody::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 5px;
    /*no*/
    background-color: rgba(0, 0, 0, 0);
}
.real-time-more{
    height: 240Px;
}
.realTimeBody::-webkit-scrollbar-thumb {
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}
.sync_detail{
    font-weight: bold;
    font-size: 14Px !important;
    margin-bottom:20Px;
}
.bottom-show{
position:absolute;
bottom:3Px;
color:red;
width:508Px;
font-size:14Px;
width:600Px;
}
.desh-show{
    line-height:15Px;
}
.desh-not-show{
     line-height:30Px;
}

.detail_txt{
    font-size: 14Px;
    color: #6f7886;
    margin-bottom: 5Px;
    float: left;
}
.catalog{
    margin-bottom: 20Px;
    width: 100%;
    margin-bottom: 20Px;
    height: 40Px;
}
.log-line {
    width: 100%;
    float: left;
}
.realtime-category-link {
    color: #4281ff;
    float: left;
    max-width: 400px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.view-logs-category-link {
    color: #4281ff;
    float: left;
    width: 160px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.realtime-category-link:hover,
.view-logs-category-link:hover {
    color: #4281ff;
    text-decoration: underline;
    cursor: pointer;
}
.log-realTimeline-left{
    float: left;
    width: 255px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.view-logs-realTime-info{
    width: 500px;
    /*no*/
    height: 40px;
    /*no*/
    position: absolute;
    z-index: 3;
    font-size: 14px;
    /*no*/
    box-sizing: border-box;
    padding: 0px 10px 0px 10px;
    /*no*/
     font-family: Arial, "Microsoft YaHei", 微软雅黑;
}

.view-reallogs-all {
    width: 100%;
    height: 300px;
    /*no*/
    overflow: auto;
}

/*定义滑块，内阴影及圆角*/

.view-reallogs-all::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 8px;
    /*no*/
    background-color: #fff;
}

.view-reallogs-all::-webkit-scrollbar-thumb {
    border-radius: 5px !important;
    /*no*/
    background-color: #becae4 !important;
    display: block !important;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

.Rotation {
  -webkit-transform: rotate(360deg);
  animation: rotation 3s linear infinite;
  -moz-animation: rotation 3s linear infinite;
  -webkit-animation: rotation 3s linear infinite;
  -o-animation: rotation 3s linear infinite;
}
.logs-realTime-box{
     width: 500px;
    /*no*/
    border: 1px solid #cdddf5;
    /*no*/
    position: relative;
    line-height: 40px;
    /*no*/
    margin-bottom: 10px;
    /*no*/
    box-sizing: border-box;
}
.realtime-logs-position{
    float: left;
    top:9Px !important;
    margin-right:8Px;
}
.view-syncInfo{
    height: 150Px;
    width: 100%;
    position: relative;
    top: 5Px;

}

/*定义滑块，内阴影及圆角*/

.view-syncInfo::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 8px;
    /*no*/
    background-color: #fff;
}

.view-syncInfo::-webkit-scrollbar-thumb {
    border-radius: 5px !important;
    /*no*/
    background-color: #becae4 !important;
    display: block !important;
    position: relative;
    left: 5px;
}

.catelog-width {
    max-width:430Px;
    float: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.catelog-width-it {
    max-width:400Px;
    float: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.startTime-format{
width:180Px;
float:left;
font-size:12Px;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}

.task-item-status{
float:left;
height:100%;
text-align:right;
line-height:37Px;
margin-left:5Px;
font-size: 12Px;
}
.show-status{
width:50Px;
float: left;
font-size: 12Px;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
text-align:left;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/view_realtime_logs_popups.vue